import { NotificationsApi } from '@/app/services/services'
import { timer, from } from 'rxjs'
import { tap, switchMap } from 'rxjs/operators'

export const Actions = {
	GET_BROWSING_TOOL_NOTIFICATIONS_SUCCESS:
		'GET_BROWSING_TOOL_NOTIFICATIONS_SUCCESS',
}

export const getBrowsingToolNotificationsSuccess = (data: any) => {
	return {
		type: Actions.GET_BROWSING_TOOL_NOTIFICATIONS_SUCCESS,
		toastList: data.notifications,
	}
}

const getBrowsingToolRequest = (dispatch) => {
	return from(NotificationsApi.getBrowsingToolNotifications()).pipe(
		tap((res: any) => {
			if (res && res.data) {
				dispatch(getBrowsingToolNotificationsSuccess(res.data))
			}
		})
	)
}

export const getBrowsingToolNotifications = () => {
	return (dispatch: any) => {
		timer(0, 300000)
			.pipe(switchMap((_) => getBrowsingToolRequest(dispatch)))
			.subscribe()
	}
}

export const getBrowsingTool = () => {
	return (dispatch) => {
		NotificationsApi.getBrowsingToolNotifications().then((res) => {
			if (res && res.data) {
				dispatch(getBrowsingToolNotificationsSuccess(res.data))
			}
		})
	}
}
